jQuery(document).ready(function($) {	
	/* Trust Pilot Review Slider */
	/* Trust Pilot Review Slider */
    // jQuery(".review_slider").owlCarousel({
    //     items: 2, //10 items above 1000px browser width
    //     itemsDesktop: [1024, 2], //5 items between 1024px and 901px
    //     itemsDesktopSmall: [768, 2], // 3 items betweem 900px and 601px
    //     itemsTablet: [767, 2],
	// 	itemsTablet: [545, 1],//2 items between 600 and 0;
    //     itemsMobile: [360, 1],
    //     navigation: true,
    //     navigationText: ["<a class=\"flex-prev\"></a>", "<a class=\"flex-next\"></a>"],
    //     slideSpeed: 500,
    //     pagination: false
    // });

    // Function to get URL parameter by name
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Use setTimeout to delay execution by 3 seconds
    setTimeout(function() {
        // Get the 'param' value from the URL
        var paramValue = getUrlParameter('productName');

        // Set the value of the input field
        $('#productName').val(paramValue);
    }, 1000);
	
	$('.featured-product-archive-page .products').addClass('row');
});

// Coupon Copy Functionality
window.asgardCopyCoupon = function(text, btn) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function() {
            asgardUpdateBtn(btn);
        }).catch(function() {
            asgardFallbackCopy(text, btn);
        });
    } else {
        asgardFallbackCopy(text, btn);
    }
}

window.asgardFallbackCopy = function(text, btn) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        if (successful) asgardUpdateBtn(btn);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
}

window.asgardUpdateBtn = function(btn) {
    var originalText = btn.innerText;
    btn.innerText = 'Copied!';
    setTimeout(function() {
        btn.innerText = originalText;
    }, 2000);
}